import { styled } from 'styled-components';

export const StyledSvgContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    max-width: 100%;
    max-height: 100%;
  }
`;
